var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.47,2.82,4.11,11.16l12,12,8.36-8.35Zm19.17,8.62L12.83,30.19l4.93,4.93L36.61,16.37ZM7.39,36.92a3.49,3.49,0,0,0,3.32,3.34h0c1.52-.09,1.52,2.13,0,2.22a5.63,5.63,0,0,1-5.56-5.56h0c.1-1.5,2.32-1.5,2.23,0ZM33.27,23.54,24.9,31.91l12,12,8.36-8.37ZM14.16.7l5.16,5.16.93.91,6.12,6.13,3.51-3.59a2.48,2.48,0,0,1,1.74-.72,2.44,2.44,0,0,1,1.73.72h0l5.31,5.3a2.43,2.43,0,0,1,.73,1.74,2.51,2.51,0,0,1-.72,1.75h0L35.1,21.62l1.67,1.66,1.53,1.54,9,9a2.47,2.47,0,0,1,0,3.49h0L38.57,46a2.47,2.47,0,0,1-3.49,0h0l-9.17-9.16-.63-.62-2.39-2.47-3.41,3.43a2.42,2.42,0,0,1-1.74.72A2.46,2.46,0,0,1,16,37.18h0l-5.31-5.31a2.47,2.47,0,0,1,0-3.49h0L14.16,25,2,12.9A2.47,2.47,0,0,1,2,9.41H2L10.72.7a2.46,2.46,0,0,1,3.44,0ZM2.21,36.45v0a8.87,8.87,0,0,0,8.87,8.87h0a1.11,1.11,0,1,1,0,2.21h0A11.09,11.09,0,0,1,0,36.47H0C-.08,35,2.21,35,2.21,36.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.86dd5707a9b797ee0b75bc14bd354965.svg";
export { ForwardRef as ReactComponent };